import $api from '@/http';
import type { IVariable } from '@/models/Forms/IForms';
import type { IField, IFieldElem } from '@/models/IFormData';
import { resolveFormVariable } from '@/utils/managers/resolveFormVariable';

export const DOCUMENT_LINK_TITLE_BATCH_SIZE = 100;

interface IDocumentLinkTitles {
    captions: Record<string, IVariable[]>;
    documents: Record<
        string,
        {
            captionKey: string;
            flowTitle?: string;
            isTemplate?: boolean;
            templateName?: string;
            fields: IField[];
        }
    >;
}

export const textValue = (value: unknown): string | undefined =>
    typeof value === 'string' && value.trim() ? value.trim() : undefined;

/** Ответ содержит только подписи доступных документов, без схем и данных карточек. */
export const loadDocumentLinkTitles = async (ids: string[], signal: AbortSignal): Promise<Record<string, string>> => {
    const { data } = await $api.post<IDocumentLinkTitles>('/document/linkTitles', ids.map(Number), {
        signal,
        suppressErrorNotification: true,
        timeout: 10000,
    });
    const titles: Record<string, string> = {};
    for (const [id, document] of Object.entries(data.documents)) {
        if (document.isTemplate && document.templateName) {
            titles[id] = `Шаблон "${document.templateName}" (${document.flowTitle})`;
            continue;
        }
        const values: Record<string, IFieldElem> = Object.fromEntries(
            document.fields.map((field, index) => [field.name, { ...field, index }]),
        );
        let title: string | undefined;
        for (const caption of data.captions[document.captionKey] ?? []) {
            try {
                title = textValue(resolveFormVariable(caption, values)) ?? title;
            } catch {
                /* Некорректная формула не должна ломать ссылку. */
            }
        }
        const flow = textValue(values['|Document|Имя_потока']?.value) ?? textValue(document.flowTitle);
        const number = values['|Document|Регистрационный_номер']?.value;
        title ??= flow
            ? [flow, number].filter((value) => value !== null && value !== undefined && value !== '').join(' ')
            : undefined;
        if (title) titles[id] = title;
    }
    return titles;
};
